var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { LoadingAFY, position, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import showToast from "../../services/toast";
import { useInsurances } from "./hook/insurances.hook";
import { InsurancesView } from "./view/insurances.view";
export var InsurancesAdmin = function () {
    var insurances = useInsurances();
    return (_jsxs(React.Fragment, { children: [_jsx(LoadingAFY, { loading: insurances.loading, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: insurances.loadingText, textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), insurances.seeToast.show &&
                showToast(position.topRight, insurances.seeToast.type, insurances.seeToast.message, insurances.closeToast), insurances.seeToastSuccess.show &&
                showToast(position.bottomRight, insurances.seeToastSuccess.type, insurances.seeToastSuccess.message, insurances.closeToastSuccess), _jsx(InsurancesView, __assign({}, insurances.view))] }));
};
export default InsurancesAdmin;
